import ForgetPassword from './container';

export default ForgetPassword;



// WEBPACK FOOTER //
// ./src/routes/ForgetPassword/index.js